$(function() {
  $(document).on('keyup', '.input-search-companies', function() {
    var word = $(this).val();
    console.log(word)
    if (word !== null && word !== "") {
      $.each($('.box-companies .company-name'), function(index, element) {
        if ($(this).text().toUpperCase().indexOf(word.toUpperCase()) !== -1) {
          $(this).parents('.box-companies').removeClass('hidden');
        } else {
          $(this).parents('.box-companies').addClass('hidden');
        }
      });
    } else {
      $('.box-companies').removeClass('hidden');
    }
  });
});